/**
 * Enum representing aggregation function options.
 */
export enum AggregationFunction {
  Avg = 0,
  Min = 1,
  Max = 2,
}
